import { useAccountSelf, useMetadata, useSelf } from 'App/components/hooks/appHooks';
import { canFindSoliditetProspects } from 'App/helpers/soliditetHelper';

export default function useFindProspectsAllowed() {
	return canFindSoliditetProspects(useSelf(), useAccountSelf(), useMetadata());
}
